/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountNav
 */
export interface AccountNav {
    /**
     * 
     * @type {string}
     * @memberof AccountNav
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof AccountNav
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof AccountNav
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof AccountNav
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountNav
     */
    nav?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountNav
     */
    cash?: number;
}

/**
 * Check if a given object implements the AccountNav interface.
 */
export function instanceOfAccountNav(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "brokerId" in value;

    return isInstance;
}

export function AccountNavFromJSON(json: any): AccountNav {
    return AccountNavFromJSONTyped(json, false);
}

export function AccountNavFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountNav {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pId': json['p_id'],
        'aC': json['a_c'],
        'brokerId': json['broker_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'nav': !exists(json, 'nav') ? undefined : json['nav'],
        'cash': !exists(json, 'cash') ? undefined : json['cash'],
    };
}

export function AccountNavToJSON(value?: AccountNav | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'p_id': value.pId,
        'a_c': value.aC,
        'broker_id': value.brokerId,
        'portfolio_guid': value.portfolioGuid,
        'nav': value.nav,
        'cash': value.cash,
    };
}

